import React, { useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import AceEditor from 'react-ace'
import FlexRow from '../../../../../../molecules/FlexRow'
import SydButton from '../../../../../../commonDesign/Button'
import FadeIn from '../../../../../../molecules/Transitions/FadeIn'

function JsxCode ({ defaultValue, onPreview, title, onReset }) {
  const editorRef = useRef(null)

  const handleBeautify = useCallback(() => {
    const editor = editorRef.current.editor
    const value = editor.getValue()

    // formatting code should go here when it doesn't break a build or explode the bundle
    try {
      editor.setValue(value)
    } catch (err) {
      console.error(err)
    }
  }, [])

  const handlePreview = useCallback((e) => {
    const editor = editorRef.current.editor
    const value = editor.getValue()

    onPreview(e, value)
  }, [onPreview])

  const handleReset = useCallback((e) => {
    onReset(e, null)
  }, [onReset])

  const handleCopy = useCallback((e) => {
    const editor = editorRef.current.editor
    e.preventDefault()
    e.stopPropagation()

    try {
      navigator.clipboard.writeText(editor.getValue())
    } catch (err) {
      console.error(err)
      alert('Unable to copy text')
    }
  }, [])

  return (
    <FadeIn
      className='flex flex-col'
      style={{
        width: '100%',
        height: 'calc(100vh - 112px)',
        // newer browsers support preventing navigation with CSS too
        overscrollBehaviorX: 'contain'
      }}
    >
      <FlexRow className='bg-neutral-200 px-2 justify-between' style={{ height: '30px', maxHeight: '30px', borderBottom: 'var(--border-neutral-thin)' }}>
        <FlexRow>
          <SydButton size='xs' variant='outline' priority='warning' className='radius-xs' onClick={handleReset}>Reset</SydButton>
          {title}
        </FlexRow>
        <FlexRow>

          <SydButton size='xs' variant='outline' className='radius-xs' onClick={handleCopy}>Copy</SydButton>
          <SydButton size='xs' variant='outline' className='radius-xs' onClick={handleBeautify}>Format</SydButton>
          <SydButton size='xs' variant='primary' className='radius-xs' onClick={handlePreview}>Preview</SydButton>
        </FlexRow>
      </FlexRow>
      <div className='flex-1'>
        <AceEditor
          ref={editorRef}
          height='calc(100%)'
          width='100%'
          mode='jsx'
          theme='xcode'
          name='jsx-editor'
          editorRef={{ $blockScroll: true }}
          defaultValue={defaultValue}
          tabSize={2}
        />
      </div>
    </FadeIn>
  )
}

JsxCode.propTypes = {
  defaultValue: PropTypes.string,
  onPreview: PropTypes.func,
  onReset: PropTypes.func,
  title: PropTypes.string
}

export default JsxCode
